import React from 'react';

import { getMarketConfig } from '@/utils/marketConfig';

import { ClientGTMScript } from './client-gtm-script';

export const GTM_SCRIPT = `
window.chewy = window.chewy || {};
window.chewy.analyticsCallback = () => {
  // [Start] Initialize Datalayer
  try {
    window.chewy.initializeDataLayer(true);
    window.chewy.initializeGTM(); 
  } catch (error) {
    console.error('Error caught in gtm', error);
    throw error;
  }
  // [End] Initialize Datalayer
  // [Start] Google Tag Manager
  try {
    (function(w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({
        "gtm.start": new Date().getTime(),
        event: "gtm.js"
      });
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != "dataLayer" ? "&l=" + l : "";
      j.async = true;
      j.src =
        "https://www.googletagmanager.com/gtm.js?id=" +
        i +
        dl +
        "{ANALYTICS_GTM_PARAMS}";
      f.parentNode.insertBefore(j, f);
    })(window, document, "script", "dataLayer", "{GTM_CONTAINER_ID}");
  } catch (error) {
      console.error('Error caught in gtm tag', error);
      throw error;
  }
  // [End] Google Tag Manager
}
`;

export const ServerGTMScript = (market: string) => {
  let gtmScript = GTM_SCRIPT.replace('{GTM_CONTAINER_ID}', getMarketConfig(market).gtmId);
  gtmScript = gtmScript.replace(
    '{ANALYTICS_GTM_PARAMS}',
    process.env.NEXT_PUBLIC_ANALYTICS_GTM_PARAMS ?? '',
  );
  return <ClientGTMScript script={gtmScript} />;
};
